<template>
    <div class="col-sm-12" style="min-height: 80vh">
        <storm-sewer-line-search
          :key="'storm-sewer-line-search'"
          :user="user"
          @search="fetchSewerLines"
        />
        <hr/>
        <storm-sewer-line-list
          :key="'storm-sewer-line-list'"
          :storm-sewer-lines="results"
          @row-clicked="editSewerLine"
        />
        <base-modal v-if="editMode" hide-footer hide-header @close="editMode = false">
            <sewer-line-wizard
                :storm-sewer-line="sewerLine"
                @close="showList"
                @close-and-update="closeAndUpdate"
            />
        </base-modal>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
  </div>
</template>


<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {downloadHelper} from "../mixins/DownloadMixin";
import {stormSewersMixin} from "@/components/mixins/StormSewersMixin";
import StormSewerLineSearch from "@/components/stormsewers/StormSewerLineSearch";
import StormSewerLineList from "@/components/stormsewers/StormSewerLineList";
import BaseModal from "@/components/BaseModal";
import SewerLineWizard from "@/components/stormsewers/SewerLineWizard";
import {inject} from "vue";

export default {
    name: 'StormSewerLines',
    components: {
        SewerLineWizard,
        BaseModal,
        StormSewerLineList,
        StormSewerLineSearch,
    },
    mixins: [restApi, downloadHelper, stormSewersMixin],
    props: {
        user: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            results: [],
            sewerLine: null,
            editMode: false,
            showWizard: false,
            loading: false,
            lastSearchedParams: null,
            showFileImporter: false,
            scrollPosition: 0
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    methods: {
        fetchSewerLines(params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.stormSewerUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            this.results = response.data
            this.loading = false
        },
        editSewerLine: function (item) {
            this.editMode = true
            this.sewerLine = this.jsonToItem(item)
        },
        closeAndUpdate: function () {
            this.sewerLine = null
            this.fetchSewerLines(this.lastSearchedParams)
            this.showList()
        },
        exportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.powerStationXlsxUrl, this.getCommonReportParams(this.lastSearchedParams), this.excelDownloadSuccess, this.fileDownloadFail)
        },
        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('power_stations.report_file_name'))
        },
        fileDownloadFail: function () {
            this.loading = false
           this.showAlert(this.$t('common.report_generation_failed'))
        },
        showList: function () {
            this.editMode = false
            this.showWizard = false
        },
        scrollTop: function () {
            this.scrollPosition = this.$refs.container.scrollTop
            this.$nextTick(function () {
                this.$refs.container.scrollTop = 0
            })
        }
    }
}
</script>
